// Fix para permitir navegación en mobile en menús con submenús
document.addEventListener('DOMContentLoaded', function() {
  // Buscar todos los details del menu drawer que tienen URL
  const detailsWithUrl = document.querySelectorAll('.menu-drawer details[data-menu-url]');
  
  detailsWithUrl.forEach(details => {
    const summary = details.querySelector('summary');
    const url = details.getAttribute('data-menu-url');
    
    // Solo aplicar si tiene una URL válida
    if (!url || url === '#' || url === '') {
      return;
    }
    
    summary.addEventListener('click', function(e) {
      const isOpen = details.hasAttribute('open');
      
      // Si ya está abierto, navegar al link
      if (isOpen) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = url;
        return;
      }
      
      // Si está cerrado, dejar que se abra normalmente
    });
  });
});
